import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined'
import { Avatar, Box, Chip, Paper, Typography } from '@mui/material'
import { useOAuth } from '@novafuturltd/core'
import React from 'react'
import { useIntl } from 'react-intl'
import CopyRow from './CopyRow'

function initialsOf(first?: string, last?: string): string {
  const a = (first ?? '').trim().charAt(0)
  const b = (last ?? '').trim().charAt(0)
  return (a + b).toUpperCase() || '?'
}

export default function AccountIdentityWidget() {
  const intl = useIntl()
  const { userId, profile, orgName, organizationId } = useOAuth()
  const id = userId ?? profile?.idUserAccount
  if (!id) {
    return null
  }
  const name = [profile?.firstName, profile?.lastName].filter(Boolean).join(' ')
  const activeOrg = profile?.organizations?.find((o) => o.idOrganization === organizationId)
  const org = activeOrg?.name ?? (orgName as string | undefined)

  return (
    <Paper variant="outlined" sx={{ p: 2, mb: 2, borderRadius: 2 }} data-test="account-identity-widget">
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
        <Avatar sx={{ bgcolor: 'primary.main', width: 40, height: 40, fontSize: 15 }}>
          {initialsOf(profile?.firstName, profile?.lastName)}
        </Avatar>
        <Box sx={{ minWidth: 0, flex: 1 }}>
          <Typography variant="subtitle1" sx={{ fontWeight: 600, lineHeight: 1.3 }} noWrap={true}>
            {name || intl.formatMessage({ id: 'caChat.identity.name.fallback' })}
          </Typography>
          {org && <Chip label={org} size="small" variant="outlined" sx={{ height: 20, mt: 0.25 }} />}
        </Box>
        <BadgeOutlinedIcon color="disabled" />
      </Box>

      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
        <CopyRow label={intl.formatMessage({ id: 'caChat.identity.label.userId' })} value={id} primary={true} />
        {organizationId && <CopyRow label={intl.formatMessage({ id: 'caChat.identity.label.orgId' })} value={organizationId} />}
      </Box>

      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 1 }}>
        {intl.formatMessage({ id: 'caChat.identity.caption' })}
      </Typography>
    </Paper>
  )
}
